import React, { useState, useEffect } from 'react';
import { apiRequest } from '../utils/api';
import Swal from 'sweetalert2';
import moment from 'moment';

const AdminNotes = ({ customerId, orderId, filterByOrder }) => {
    const [notes, setNotes] = useState([]);
    const [text, setText] = useState('');

    useEffect(() => {
        if (customerId) {
            fetchNotes();
        }
    }, [customerId]);

    const fetchNotes = async () => {
        try {
            let url = `/admin/notes/${customerId}`;
            if (filterByOrder && orderId) {
                url += `?orderId=${orderId}`;
            }
            const res = await apiRequest.get(url);
            if (res.data.status === 200) {
                setNotes(res.data.message);
            }
        } catch (error) {
            console.error("Error fetching notes:", error);
        }
    };

    const handleSaveNote = async () => {
        if (!text.trim()) return;
        try {
            const payload = { customerId, orderId, note: text };
            const res = await apiRequest.post('/admin/notes', payload);
            if (res.data.status === 200) {
                setText('');
                fetchNotes(); // refresh list
            } else {
                Swal.fire({ icon: "error", title: "Oops...", text: res.data.message || "Failed to save note!" });
            }
        } catch (error) {
            console.error("Error saving note:", error);
            Swal.fire({ icon: "error", title: "Oops...", text: "An error occurred." });
        }
    };

    const handleDeleteNote = (noteId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this note!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await apiRequest.delete(`/admin/notes/${noteId}`);
                    if (res.data.status === 200) {
                        fetchNotes();
                        Swal.fire("Deleted!", "Your note has been deleted.", "success");
                    }
                } catch (error) {
                    console.error("Error deleting note:", error);
                }
            }
        });
    };

    const handleEditNote = (note) => {
        Swal.fire({
            title: 'Edit Note',
            input: 'textarea',
            inputValue: note.note,
            showCancelButton: true,
            confirmButtonText: 'Update'
        }).then(async (result) => {
            if (result.isConfirmed && result.value) {
                try {
                    const res = await apiRequest.put(`/admin/notes/${note.note_id}`, { note: result.value });
                    if (res.data.status === 200) {
                        fetchNotes();
                        Swal.fire("Updated!", "Your note has been updated.", "success");
                    }
                } catch (error) {
                    console.error("Error updating note:", error);
                }
            }
        });
    }

    return (
        <>
            <div className="admin-notes-list">
                {notes.map((note, i) => (
                    <div className="admin-note-item" key={note.note_id || i}>
                        <div className='admin-notes-content'>
                            <div className="admin-name">{note.updated_by || note.created_by}</div>
                            <p>{note.note}</p>
                        </div>
                        <div className="admin-note-right">
                            <div className="admin-note-date">{moment(note.updated_at).format('MMM D, YYYY [at] h:mm A')}</div>
                            <div className="edit-delet">
                                <button type='button' className='btn edit-btn' onClick={() => handleEditNote(note)}><img src='/img/eye.png' alt='Edit' /></button>
                                <button type='button' className='btn delete-btn' onClick={() => handleDeleteNote(note.note_id)}><img src='/img/trash.png' alt='Delete' /></button>
                            </div>
                        </div>
                    </div>
                ))}
                {notes.length === 0 && <p style={{textAlign: "center", color: "#888", marginBottom: "30px"}}>No notes found for this customer.</p>}
            </div>

            <div className="admin-note-form">
                <div className="form-group">
                    <textarea 
                       className="form-control" 
                       rows={5} 
                       placeholder='Add a new admin note...'
                       value={text}
                       onChange={(e) => setText(e.target.value)}
                    ></textarea>
                </div>
                <button type='button' className='btn save-notes-btn' onClick={handleSaveNote}>Save Note</button>
            </div>
        </>
    )
}

export default AdminNotes;